import React, { useContext } from 'react';

import { isModule } from '../../helpers/windowLocation';
import { InfoContext } from '../../context';
import { ConvertToPDFButton } from './ConvertToPDFButton';
import { UploadButton } from './UploadButton';
import { AbilityContext } from '../../abilities/Can';
import { CTAWorkflow } from './CTAWorkflow';

/*
 * bynder-platform/bynder/views/navigation/header.cfm
 * TODO: Move JQuery logic. Search for it using "uploadContainer" id
 */

export function CTAButton() {
	const { primaryCTA } = useContext(InfoContext);
	const ability = useContext(AbilityContext);

	if (isModule('workflow')) {
		return <CTAWorkflow />;
	}

	if (primaryCTA.id !== 'uploadMedia') {
		return <ConvertToPDFButton />;
	}

	const canShowUpload = ability.can('show', 'upload_media');

	if (canShowUpload) {
		return <UploadButton />;
	}

	return null;
}
